import { FC, useContext } from 'react';
import { ObjectPageContext } from '../../../pages/Context/ObjectPageContext';

type Props = {
  historyModal: boolean;
};

const ShowHistory: FC<Props> = ({ historyModal }) => {
  const { isBigScreen } = useContext(ObjectPageContext);
  return (
    <div className="items-center mx-auto flex justify-center my-3">
      <img
        alt="Icon arrow"
        className={`${historyModal ? '' : 'rotate-180'} w-3`}
        loading="lazy"
        width="12"
        height="7"
        src={
          isBigScreen
            ? '/Images/Icons/Arrows/arrow-up-white.svg'
            : '/Images/Icons/Arrows/arrow-up-blue.svg'
        }
      />
      <span className="text-center block mx-4">Visa budhistorik</span>
      <img
        alt="Icon arrow"
        loading="lazy"
        width="12"
        height="7"
        className={`${historyModal ? '' : 'rotate-180'} w-3`}
        src={
          isBigScreen
            ? '/Images/Icons/Arrows/arrow-up-white.svg'
            : '/Images/Icons/Arrows/arrow-up-blue.svg'
        }
      />
    </div>
  );
};
export default ShowHistory;
